import '../../../base_builders/vertical/rcp/rcp_base_builder';

// import rc_newsletters from '../../../../assets/top/rc-newsletters-v2.js';
import Newsletters from '../../../../assets/js/Newsletters/Newsletters';
Newsletters();

import Comments from "../../../../assets/js/Widgets/SpotIM/Comments";
Comments();

import Articles from "../../../../assets/js/Articles/Articles.js";
Articles();


import RcmgSpot from '../../../../assets/js/RCMG_V2/RcmgSpot.js';